import { Entity, Field } from "typegraph";

import Tag from './Tag'

@Entity({one: "subscriptionTag", many: "subscriptionTags"})
export default class SubscriptionTag {

	@Field()
	public type: string;

	@Field({entity: Tag})
	public tag: Tag;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/entities/SubscriptionTag.ts